import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["accessibilityLabelClearButton", "className", "clearButton", "disabled", "error", "focus", "iconLeft", "iconLeftComponent", "id", "labelId", "mask", "messageId", "name", "onChange", "onIconBlur", "onIconLeftClick", "onRequestClear", "required", "type", "value"];
import React, { forwardRef } from 'react';
import cx from 'classnames';
import { useMergeRefs } from 'use-callback-ref';
import { Close } from '@mediahuis/chameleon-theme-wl/icons';
import Icon from '../Icon';
import IconButton from '../IconButton';
import { useInputMask } from '../../hooks';
import styles from './index.module.scss';

var IconLeft = function IconLeft(_ref) {
  var icon = _ref.icon,
      clickable = _ref.clickable,
      onClick = _ref.onClick,
      className = _ref.className;

  if (clickable) {
    return /*#__PURE__*/React.createElement(Icon, {
      onClick: onClick,
      onKeyDown: function onKeyDown(e) {
        if (e.keyCode === 32) {
          onClick(e);
        }
      },
      tabIndex: "0",
      role: "button",
      className: cx(className, styles.iconLeftClickable),
      as: icon
    });
  }

  return /*#__PURE__*/React.createElement(Icon, {
    className: cx(className, styles.iconNoPointerEvents),
    as: icon
  });
};

var Input = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var accessibilityLabelClearButton = _ref2.accessibilityLabelClearButton,
      className = _ref2.className,
      clearButton = _ref2.clearButton,
      disabled = _ref2.disabled,
      error = _ref2.error,
      focus = _ref2.focus,
      iconLeft = _ref2.iconLeft,
      iconLeftComponent = _ref2.iconLeftComponent,
      id = _ref2.id,
      labelId = _ref2.labelId,
      mask = _ref2.mask,
      messageId = _ref2.messageId,
      name = _ref2.name,
      onChange = _ref2.onChange,
      onIconBlur = _ref2.onIconBlur,
      onIconLeftClick = _ref2.onIconLeftClick,
      onRequestClear = _ref2.onRequestClear,
      required = _ref2.required,
      type = _ref2.type,
      value = _ref2.value,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded);

  var internalInputRef = React.useRef(null);
  var combinedRef = useMergeRefs([internalInputRef, ref]);
  useInputMask(combinedRef, mask);
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.root, className)
  }, /*#__PURE__*/React.createElement("input", _extends({
    "aria-describedby": messageId,
    "aria-labelledby": labelId,
    "aria-invalid": !!error,
    "aria-required": required ? 'true' : 'false',
    className: cx(styles.field, error && styles.error, clearButton && styles.fieldClearButton, (iconLeft || iconLeftComponent) && styles.fieldIconLeft),
    disabled: disabled,
    id: id,
    name: name,
    onChange: onChange,
    required: required,
    type: type,
    value: value,
    ref: combinedRef
  }, rest)), !iconLeftComponent && iconLeft && /*#__PURE__*/React.createElement(IconLeft, {
    clickable: onIconLeftClick && !disabled,
    onClick: onIconLeftClick,
    className: cx(styles.icon, styles.iconLeftContainer),
    icon: iconLeft
  }), iconLeftComponent && /*#__PURE__*/React.createElement("span", {
    className: cx(styles.icon, styles.iconLeftContainer)
  }, iconLeftComponent), clearButton && value && /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    icon: Close,
    circular: true,
    appearance: "default",
    disabled: disabled,
    className: styles.icon,
    accessibilityLabel: accessibilityLabelClearButton,
    tabIndex: -1,
    onClick: function onClick() {
      if (onRequestClear && typeof onRequestClear === 'function') {
        onRequestClear();
      } else {
        onChange({
          target: {
            value: ''
          }
        });
      }

      combinedRef.current.focus();
    },
    right: 4
  }));
});
Input.displayName = 'Input';
Input.identifier = Input.displayName; // used in docs website

Input.defaultProps = {
  type: 'text',
  accessibilityLabelClearButton: 'Clear'
};
export default Input;